<template>
  <div class="register-page">
    <div class="register-container">
      <n-card title="Register" style="max-width: 400px; margin: 0 auto;">
        <n-form :model="formData" :rules="rules" ref="formRef">
          <n-form-item label="Name" path="name">
            <n-input v-model:value="formData.name" placeholder="Enter your name" />
          </n-form-item>
          <n-form-item label="Email" path="email">
            <n-input v-model:value="formData.email" placeholder="Enter your email" />
          </n-form-item>
          <n-form-item label="Password" path="password">
            <n-input 
              v-model:value="formData.password" 
              type="password" 
              placeholder="Enter your password"
              @keyup.enter="handleRegister"
            />
          </n-form-item>
          <n-form-item>
            <n-button 
              type="primary" 
              @click="handleRegister" 
              :loading="loading"
              block
            >
              Register
            </n-button>
          </n-form-item>
        </n-form>
        <n-divider />
        <div class="auth-footer">
          <p>Already have an account?</p>
          <n-button @click="$router.push('/login')" type="primary" ghost>
            Login
          </n-button>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useMessage } from 'naive-ui'
import { apiClient, type RegisterRequest } from '@/services/api'

const router = useRouter()
const message = useMessage()
const formRef = ref()
const loading = ref(false)

const formData = reactive<RegisterRequest>({
  name: '',
  email: '',
  password: '',
})

const rules = {
  name: {
    required: true,
    message: 'Please enter your name',
    trigger: 'blur',
  },
  email: {
    required: true,
    message: 'Please enter your email',
    trigger: 'blur',
  },
  password: [
    {
      required: true,
      message: 'Please enter your password',
      trigger: 'blur',
    },
    {
      min: 6,
      message: 'Password must be at least 6 characters',
      trigger: 'blur',
    }
  ],
}

const handleRegister = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    
    await apiClient.register(formData)
    message.success('Registration successful! Please login.')
    
    // Redirect to login
    router.push('/login')
  } catch (error) {
    message.error('Registration failed. Please try again.')
    console.error(error)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.register-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--body-color);
}

.register-container {
  width: 100%;
  max-width: 400px;
  padding: 24px;
}

.auth-footer {
  text-align: center;
}

.auth-footer p {
  margin: 0 0 12px 0;
  color: #666;
}
</style>
